import React, {
    PropTypes,
} from 'react';
import {Table} from 'react-bootstrap';

const HistoryTable = ({history, ShowHistoryEntry, user, total}) => {
    const historyItems = history.map((v) => {
        return <tr>
            <td>
                <a
                    href='#'
                    style={{textDecoration: 'underline'}}
                    onClick={e => {
                        e.preventDefault();
                        ShowHistoryEntry(user.id, user.type, v.orderDate);
                    }}>
                    Разом по замовленню харчування за {v.orderDate}
                </a>
            </td>
            <td>{v.orderTotal}</td>
        </tr>;
    });
    return (
        <Table condensed hover className="mt15 my-table">
            <thead>
            <tr>
                <th width="50%">Дата</th>
                <th>Вартість замовлення, ₴</th>
            </tr>
            </thead>
            <tbody>
            {historyItems}
            </tbody>
            <tfoot>
            <tr>
                <td>Разом за обраний період</td>
                <td>{total}</td>
            </tr>
            </tfoot>
        </Table>
    );
};

HistoryTable.propTypes = {
    history: PropTypes.array.isRequired,
    total: PropTypes.number.isRequired,
    user: PropTypes.object.isRequired,
    ShowHistoryEntry: PropTypes.func.isRequired
};

export default HistoryTable;



/** WEBPACK FOOTER **
 ** ./src/modules/food/HistoryTable.js
 **/